import { ENABLE_CODE_SECTION } from "@/constants/accessControl";
import { STATE_ENABLED_EVALUATE, STATES_REQUEST_FINISH } from "@/constants/commons";
import { SegcenFormat } from "@/interfaces/AccessControl";
import { AddPercentageSurchargeForm } from "@/interfaces/evaluation";
import { validateSegcenPermissions } from "@/utils/accessControlUser";
import { getEnvironmentVariable } from "@/utils/environment";
import { RegisterOptions } from "react-hook-form";

export const getPermissionEvaluation = (actionCode: string, segcen: SegcenFormat): boolean => {
  return validateSegcenPermissions({
    segcen,
    object: getEnvironmentVariable("VITE_APP_SEGCEM_DETAIL_EVALUATE", ""),
    action: actionCode
  });
}

export const disabledSaveEvaluate = ({ evaluationUser, fullName, requestStatusCode, segcen }:
  { evaluationUser: string, fullName: string, requestStatusCode: number, segcen: SegcenFormat }) => {
  const isAssinedRequestToCurrentUser = evaluationUser.toLowerCase() === fullName.toLowerCase();
  const hasFinalStates = STATES_REQUEST_FINISH.includes(requestStatusCode ?? -1);
  const allowSaveEvaluate = getPermissionEvaluation(ENABLE_CODE_SECTION.DETAIL_SAVE_EVALUATE, segcen);
  return (!isAssinedRequestToCurrentUser || Boolean(hasFinalStates)) || (Boolean(!hasFinalStates) && !allowSaveEvaluate);
};

export const disabledAnnularEvaluate = ({ evaluationUser, fullName, requestStatusCode, segcen }:
  { evaluationUser: string, fullName: string, requestStatusCode: number, segcen: SegcenFormat }) => {
  const isAssinedRequestToCurrentUser = evaluationUser.toLowerCase() === fullName.toLowerCase();
  const hasFinalStates = STATES_REQUEST_FINISH.includes(requestStatusCode ?? -1);
  const allowAnnularEvaluate = getPermissionEvaluation(ENABLE_CODE_SECTION.DETAIL_ANNULAR_EVALUATE, segcen);
  return (!isAssinedRequestToCurrentUser || Boolean(hasFinalStates)) || (Boolean(!hasFinalStates) && !allowAnnularEvaluate);
};

export const enabledAddObservationValid = ({ requestStatusCode, isEvaluatorRol, evaluationUser, fullName, segcen }:
  { requestStatusCode: number, isEvaluatorRol: boolean, evaluationUser: string, fullName: string, segcen: SegcenFormat }) => {
  const existEnableEvaluate = STATE_ENABLED_EVALUATE.includes(requestStatusCode ?? -1);
  const isAssinedRequestToCurrentUser = evaluationUser.toLowerCase() === fullName.toLowerCase();
  const allowAddObservation = getPermissionEvaluation(ENABLE_CODE_SECTION.DETAIL_ADD_OBSERVATION_EVALUATE, segcen);
  return existEnableEvaluate && isEvaluatorRol && isAssinedRequestToCurrentUser && allowAddObservation;
}

export const enabledAddDocumentPostEvaluateValid = ({ requestStatusCode, isEvaluatorRol, evaluationUser, fullName, segcen }:
  { requestStatusCode: number, isEvaluatorRol: boolean, evaluationUser: string, fullName: string, segcen: SegcenFormat }) => {
  const existEnableEvaluate = STATES_REQUEST_FINISH.includes(requestStatusCode ?? -1);
  const isAssinedRequestToCurrentUser = evaluationUser.toLowerCase() === fullName.toLowerCase();
  const allowAddDocumentPostEvaluate = getPermissionEvaluation(ENABLE_CODE_SECTION.DETAIL_ADD_DOCUMENT_POST_EVALUATE, segcen);
  return existEnableEvaluate && isEvaluatorRol && isAssinedRequestToCurrentUser && allowAddDocumentPostEvaluate;
}

export const enabledAddRequirementValid = ({evaluationUser, fullName, segcen, requestStatusCode}:
  {evaluationUser: string, fullName: string, segcen: SegcenFormat, requestStatusCode: number}) => {
  const existEnableEvaluate = STATE_ENABLED_EVALUATE.includes(requestStatusCode ?? -1);
  const isAssinedRequestToCurrentUser = evaluationUser.toLowerCase() === fullName.toLowerCase();
  const allowAddRequirement = getPermissionEvaluation(ENABLE_CODE_SECTION.DETAIL_ADD_NEW_REQUIREMENT_EVALUATE, segcen);
  return existEnableEvaluate && isAssinedRequestToCurrentUser && allowAddRequirement;
}

export const getSurchargeRules = (): RegisterOptions<AddPercentageSurchargeForm, 'surcharge'> => ({
  required: 'Es requerido el campo recargo',
});

export const getYearForThousandRules = (): RegisterOptions<AddPercentageSurchargeForm, 'yearForThousand'> => ({
  required: 'Es requerido el campo por mil',
  validate: (value) => value >= 1 || 'El campo por mil debe ser mayor o igual a 1',
});

export const getReasonRules = (): RegisterOptions<AddPercentageSurchargeForm, 'reason'> => ({
  required: 'Es requerido el campo motivo',
});

export const getCommentRules = (): RegisterOptions<AddPercentageSurchargeForm, 'comment'> => ({
  required: 'Es requerido el campo comentario',
  validate: (value) => value.trim().length > 0 || 'El comentario no puede contener solo espacios',
});